export default __webpack_public_path__ + "9c69fab1260fdac017490e20c1348ade.png";